import { animateChild, query, transition, trigger } from '@angular/animations';

export const nestedAnimations = () => {
	return trigger('nestedAnimations', [transition('* => *', [query('@*', animateChild(), { optional: true })])]);
};
